'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _PageHeader = require('react-bootstrap/lib/PageHeader');

var _PageHeader2 = _interopRequireDefault(_PageHeader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _PageHeader2.default;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@sketchpixy/rubix/lib/PageHeader.js
 ** module id = ./node_modules/@sketchpixy/rubix/lib/PageHeader.js
 ** module chunks = 0
 **/